// extracted by mini-css-extract-plugin
export var cardContent = "card-content-module--card-content--b3JeJ";